import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import './Footer.css';

// Map each footer link's href to its route pathname(s)
const NAV_LINKS = [
  { label: 'Sell Online',            href: '/sellonline',   paths: ['/sellonline'] },
  { label: 'Grow',                   href: '/grow',         paths: ['/grow'] },
  { label: 'How it works',           href: '/how-it-works', paths: ['/how-it-works'] },
  { label: 'Pricing & Commission',   href: '/pricing',      paths: ['/pricing'] },
  { label: 'Shipping & Returns',     href: '/shipping',     paths: ['/shipping'] },
  { label: 'Newsroom',               href: '/newsroom',     paths: ['/newsroom'] },
  { label: 'Seller Advertising Hub', href: '/advertising',  paths: ['/advertising'] },
];

export default function Footer() {
  const { pathname } = useLocation();

  return (
    <footer className="b2b-footer" id="footer">
      <div className="container">
        {/* Let's Work Together top section */}
        <div className="footer-top-row">
          <h2 className="footer-heading">Let's Work Together</h2>
          <a href="/contactus" className="footer-contact-link">
            <button className="footer-contact-btn">Contact Us</button>
          </a>
        </div>

        {/* Horizontal separator */}
        <hr className="footer-hr" />

        {/* Columns section */}
        <div className="footer-columns">
          {/* Column 1: Address and Info */}
          <div className="footer-col-address">
            <p className="footer-text-address">
              #126, RNS Plaza, KIADB Layout, 1 st Main, near Tech Mahindra gate 1 , Electronic City Phase 2, Doddanagamangala road , Bengaluru, Karnataka 560100
            </p>
            <p className="footer-contact-info">
              <strong>E-Mail:</strong> <a href="mailto:sales@haatza.com">sales@haatza.com</a>
            </p>
            <p className="footer-contact-info">
              <strong>Phone:</strong> +91- 914 807 9015
            </p>
          </div>

          {/* Column 2: Navigation Links */}
          <div className="footer-col-links">
            <ul className="footer-links-grid">
              {NAV_LINKS.map(({ label, href, paths }) => {
                const isActive = paths.some(
                  (p) => pathname === p || pathname.startsWith(p + '/')
                );
                return (
                  <li key={href}>
                    {isActive ? (
                      <span
                        className="footer-nav-link footer-nav-link--active"
                        aria-current="page"
                        aria-disabled="true"
                        tabIndex={-1}
                        style={{
                          color: 'rgba(255, 255, 255, 0.22)',
                          opacity: 1,
                          pointerEvents: 'none',
                          cursor: 'default',
                          userSelect: 'none',
                          textDecoration: 'none',
                          fontSize: '0.95rem',
                          fontWeight: 400,
                          display: 'inline-flex',
                          alignItems: 'center',
                        }}
                      >
                        {label}
                      </span>
                    ) : (
                      <Link to={href}>{label}</Link>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>

          {/* Column 3: Social and Copyright */}
          <div className="footer-col-social">
            <div className="footer-social-icons seller-portal-footer-social-icons">
              {/* Facebook */}
              <a 
                href="https://www.facebook.com/haatzaseller/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-icon seller-portal-footer-social-icon seller-portal-footer-facebook" 
                aria-label="Facebook"
              >
                <svg width="30" height="30" viewBox="0 0 32 32" fill="none">
                  <circle cx="16" cy="16" r="16" fill="#ffffff" />
                  <path d="M21 16.5h-3v8.5h-3.5v-8.5h-2v-3h2v-2.2c0-2.3 1.4-3.6 3.4-3.6.96 0 1.8.07 2.04.1v2.36h-1.4c-1.1 0-1.3.53-1.3 1.28v2.06h2.7L21 16.5z" fill="#2563eb" />
                </svg>
              </a>
              {/* LinkedIn */}
              <a 
                href="https://www.linkedin.com/company/haatza-seller/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-icon seller-portal-footer-social-icon seller-portal-footer-linkedin" 
                aria-label="LinkedIn"
              >
                <svg width="30" height="30" viewBox="0 0 32 32" fill="none">
                  <circle cx="16" cy="16" r="16" fill="#ffffff" />
                  <path d="M10 13.5h3v9.5h-3v-9.5zm1.5-4.25a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5zm4.5 4.25h2.8v1.35h.04c.39-.74 1.34-1.5 2.76-1.5 2.96 0 3.5 1.95 3.5 4.5V23h-3v-5.1c0-1.22-.02-2.8-1.7-2.8-1.7 0-1.96 1.33-1.96 2.7V23h-3v-9.5z" fill="#2563eb" />
                </svg>
              </a>
              {/* Instagram */}
              <a 
                href="https://www.instagram.com/haatzaseller/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-icon seller-portal-footer-social-icon seller-portal-footer-instagram" 
                aria-label="Instagram"
              >
                <svg width="30" height="30" viewBox="0 0 32 32" fill="none">
                  <circle cx="16" cy="16" r="16" fill="#ffffff" />
                  <rect x="9.5" y="9.5" width="13" height="13" rx="3.5" stroke="#2563eb" strokeWidth="1.8" fill="none" />
                  <circle cx="16" cy="16" r="3.2" stroke="#2563eb" strokeWidth="1.8" fill="none" />
                  <circle cx="19.5" cy="12.5" r="0.9" fill="#2563eb" />
                </svg>
              </a>
            </div>
            
            <div className="footer-copyright-wrapper">
              <p className="footer-copyright">
                Copyright © 2025 Haatza India Pvt Ltd. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
